import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorHandler } from './utils/errorHandler'
import { MonitoringSystem } from './utils/monitoring'
import { IntelligentCache } from './utils/cache'
// import { PWAManager } from './utils/pwa'
import { TestRunner } from './utils/testRunner'
import { DeployManager } from './utils/deployManager'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Initialize error handler
const errorHandler = ErrorHandler.getInstance();

// Initialize systems
const monitoring = MonitoringSystem.getInstance();
const cache = IntelligentCache.getInstance();
// const pwa = PWAManager.getInstance();
const testRunner = TestRunner.getInstance();
const deployManager = DeployManager.getInstance();

// Initialize React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      gcTime: 10 * 60 * 1000, // 10 minutos (anteriormente cacheTime)
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
});

// Global error handling
window.addEventListener('error', (event) => {
  errorHandler.logError(event.error, 'GlobalError');
});

window.addEventListener('unhandledrejection', (event) => {
  errorHandler.logError(new Error(event.reason), 'UnhandledPromiseRejection');
});

// Performance monitoring
if ('performance' in window) {
  window.addEventListener('load', () => {
    const perfData = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    console.log('App Load Time:', perfData.loadEventEnd - perfData.fetchStart, 'ms');
    
    // Start monitoring after load
    setTimeout(() => {
      monitoring.startMonitoring();
      console.log('🔍 Sistema de monitoramento iniciado');
    }, 2000);
  });
}

// Development tools (only in development)
if (import.meta.env.DEV) {
  // Expose systems to window for debugging
  (window as any).systems = {
    monitoring,
    cache,
    // pwa,
    testRunner,
    deployManager,
    errorHandler,
    queryClient
  };
  
  console.log('🛠️ Ferramentas de desenvolvimento disponíveis em window.systems');
  
  // Auto-run tests in development
  setTimeout(async () => {
    console.log('🧪 Executando testes automatizados...');
    await testRunner.runAllTests();
  }, 5000);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)